// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar-menu-root {
    color: #6c757d !important;
    display: grid;
    /* padding: 0 1rem; */
}



.sidebar-summary-text:hover {
    color: inherit !important
}

.sidebar-summary {
    min-height: auto !important;
}

.sidebar-summary:hover {
    opacity: 0.85;
}

.sidebar-menu-root::before {
    background-color: transparent !important;
}

.sidebar-summary .MuiAccordionSummary-content {
    margin: 0 !important;
    /* padding: 0.5rem 0; */
}

.sidebar-summary-div {
    display: flex;
    width: 100%;
}

.sidebar-submenu-text {
    color: inherit;
    transition: .2s;
    margin-left: 1rem;
}

.sidebar-submenu-text:hover {
    color: inherit !important
}

.sidebar-submenu-text.sideBar-active-submenu:hover {
    color: white !important;
    opacity: 0.85;
}

.sidebar-summary-text {
    color: inherit;
    transition: .2s;
    width: 100%;
}

.sidebar-ml-add-animation {
    animation: addMarginAnimation 0s forwards ease;
}

.sidebar-ml-remove-animation {
    animation: removeMarginAnimation 0s forwards ease;
}

.sidebar-title-text {
    transition: 0.2s;
    white-space: nowrap;
}

.active-sidebar-menu {
    background-color: #24b7aa !important;
    color: #ffff !important
}

.active-sidebar-menu:hover {
    color: #ffff !important
}

.notificationCount {
    background-color: #F53535;
    position: absolute;
    right: -7px;
    top: -4px;
    border-radius: 50%;
    height: 17px;
    width: 17px;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    color: white !important;
}

@keyframes addMarginAnimation {
    /* from {
        margin-left: 0rem;
    }

    to {
        margin-left: 1rem
    } */
}

@keyframes removeMarginAnimation {
    from {
        margin-left: 1rem;
    }

    to {
        margin-left: 0rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/reusableComponents/sideBarMenu/sideBarMenu.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,aAAa;IACb,qBAAqB;AACzB;;;;AAIA;IACI;AACJ;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,oBAAoB;IACpB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI;AACJ;;AAEA;IACI,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,WAAW;AACf;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;IACpC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI;;;;;;OAMG;AACP;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;AACJ","sourcesContent":[".sidebar-menu-root {\n    color: #6c757d !important;\n    display: grid;\n    /* padding: 0 1rem; */\n}\n\n\n\n.sidebar-summary-text:hover {\n    color: inherit !important\n}\n\n.sidebar-summary {\n    min-height: auto !important;\n}\n\n.sidebar-summary:hover {\n    opacity: 0.85;\n}\n\n.sidebar-menu-root::before {\n    background-color: transparent !important;\n}\n\n.sidebar-summary .MuiAccordionSummary-content {\n    margin: 0 !important;\n    /* padding: 0.5rem 0; */\n}\n\n.sidebar-summary-div {\n    display: flex;\n    width: 100%;\n}\n\n.sidebar-submenu-text {\n    color: inherit;\n    transition: .2s;\n    margin-left: 1rem;\n}\n\n.sidebar-submenu-text:hover {\n    color: inherit !important\n}\n\n.sidebar-submenu-text.sideBar-active-submenu:hover {\n    color: white !important;\n    opacity: 0.85;\n}\n\n.sidebar-summary-text {\n    color: inherit;\n    transition: .2s;\n    width: 100%;\n}\n\n.sidebar-ml-add-animation {\n    animation: addMarginAnimation 0s forwards ease;\n}\n\n.sidebar-ml-remove-animation {\n    animation: removeMarginAnimation 0s forwards ease;\n}\n\n.sidebar-title-text {\n    transition: 0.2s;\n    white-space: nowrap;\n}\n\n.active-sidebar-menu {\n    background-color: #24b7aa !important;\n    color: #ffff !important\n}\n\n.active-sidebar-menu:hover {\n    color: #ffff !important\n}\n\n.notificationCount {\n    background-color: #F53535;\n    position: absolute;\n    right: -7px;\n    top: -4px;\n    border-radius: 50%;\n    height: 17px;\n    width: 17px;\n    font-size: 12px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: 600;\n    color: white !important;\n}\n\n@keyframes addMarginAnimation {\n    /* from {\n        margin-left: 0rem;\n    }\n\n    to {\n        margin-left: 1rem\n    } */\n}\n\n@keyframes removeMarginAnimation {\n    from {\n        margin-left: 1rem;\n    }\n\n    to {\n        margin-left: 0rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
